import { render, staticRenderFns } from "./MultiColumnList.vue?vue&type=template&id=9dcc81e4&scoped=true"
import script from "./MultiColumnList.vue?vue&type=script&lang=js"
export * from "./MultiColumnList.vue?vue&type=script&lang=js"
import style0 from "./MultiColumnList.vue?vue&type=style&index=0&id=9dcc81e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dcc81e4",
  null
  
)

export default component.exports